// extracted by mini-css-extract-plugin
module.exports = {"form":"Form-module--form--9je5h"};